import { $ } from "../../dom";
import { Input, type InputOptions } from "../core";

export type VirtualInputOptions<T> = InputOptions<T> & {
  getValue: () => T;
  setValue: (value: T) => void;

  checkValidity?: (value: T) => boolean;
};

export abstract class VirtualInput<T> extends Input<T> {
  private getValue: () => T;
  private setValue: (value: T) => void;

  private checkValidity?: (value: T) => boolean;

  constructor(options: VirtualInputOptions<T>) {
    const { getValue, setValue, checkValidity, ...superOptions } = options;

    super($.make(), superOptions);

    this.getValue = getValue;
    this.setValue = setValue;

    this.checkValidity = checkValidity;
  }

  get value(): T {
    return this.getValue();
  }

  set value(value: T) {
    this.setValue(value);
  }

  get data(): T {
    return this.value;
  }
}
